/** True si el término de búsqueda es solo dígitos (búsqueda por nro. comprobante). */
export function esBusquedaNroComprobante(term: string): boolean {
  return /^\d+$/.test(term.trim());
}

/**
 * Coincide si el nro. de comprobante contiene el término (ej. "137" → 13735 / 00013735).
 */
export function coincideNroComprobante(
  nroComprobante: number | string | null | undefined,
  termino: string
): boolean {
  const t = termino.trim();
  if (!t) return true;
  const raw = String(nroComprobante ?? '').trim();
  if (!raw) return false;
  const digits = raw.replace(/\D/g, '');
  if (!digits) return false;
  const sinCeros = digits.replace(/^0+/, '') || '0';
  const padded = digits.padStart(8, '0');
  return digits.includes(t) || sinCeros.includes(t) || padded.includes(t);
}

/** Coincide contra el comprobante visible (84, 00000084 o X-00001-00000084) y textos extra. */
export function coincideComprobanteVisible(
  termino: string,
  parts: {
    letra?: string | null;
    nroSuc?: number | null;
    nroComprobante?: number | string | null;
    nroFormulario?: number | string | null;
    textos?: Array<string | null | undefined>;
  }
): boolean {
  const t = termino.trim().toLowerCase();
  if (!t) return true;
  if (coincideNroComprobante(parts.nroComprobante, t)) return true;
  if (parts.nroFormulario != null && String(parts.nroFormulario).toLowerCase().includes(t)) return true;

  const letra = (parts.letra ?? '').trim().toLowerCase();
  const suc = parts.nroSuc != null && parts.nroSuc !== undefined
    ? String(parts.nroSuc).padStart(5, '0')
    : '';
  const nroDigits = String(parts.nroComprobante ?? '').replace(/\D/g, '');
  const nro = nroDigits ? nroDigits.replace(/^0+/, '').padStart(8, '0') : '';
  const visible = letra && suc && nro ? `${letra}-${suc}-${nro}` : '';
  if (visible.includes(t)) return true;

  return (parts.textos ?? []).some((texto) => (texto ?? '').toLowerCase().includes(t));
}
